/** Pipeline stages in the exact order they run (the order is a product requirement). */
export const STAGES = [
  "transcript_analysis",
  "topic_segmentation",
  "speaker_attribution",
  "agenda",
  "summary",
  "notes",
  "follow_ups",
  "suggestions",
] as const;
export type Stage = (typeof STAGES)[number];

export const MEETING_STATUSES = [
  "UPLOAD_PENDING",
  "UPLOADED",
  "TRANSCRIBING",
  "ANALYZING",
  "COMPLETED",
  "FAILED",
] as const;
export type MeetingStatus = (typeof MEETING_STATUSES)[number];

export const OUTPUT_LANGUAGES = ["ko", "en", "auto"] as const;
export type OutputLanguage = (typeof OUTPUT_LANGUAGES)[number];

export const ACTIVE_STATUSES: readonly MeetingStatus[] = ["UPLOAD_PENDING", "UPLOADED", "TRANSCRIBING", "ANALYZING"];

export const CONSTRAINTS = {
  /** Only mp3 is accepted (product decision). */
  allowedContentTypes: ["audio/mpeg"] as readonly string[],
  maxUploadBytes: 500 * 1024 * 1024,
  /** STT async invocation is capped at 3600s by SageMaker; 4h of audio is the hard input limit. */
  maxAudioDurationSec: 4 * 3600,
  maxActiveMeetingsPerUser: 3,
  presignedUrlExpirySec: 3600,
  taskTokenTtlSec: 2 * 24 * 3600,
} as const;
